import { render, staticRenderFns } from "./UpdateSystem.vue?vue&type=template&id=9136306e&scoped=true"
import script from "./UpdateSystem.vue?vue&type=script&lang=js"
export * from "./UpdateSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9136306e",
  null
  
)

export default component.exports